import React from 'react';
import HomeImage from '../Images/HomeImage.jpg'; 
import OurServices from '../Components/services';
import CollaboratorGrid from '../Components/collaborators';
import Team from '../Components/ourTeam';
import exploreIcon from '../Images/next.png'

const Home = () => {
    return (
        <div className="home-section">
            <div className="home-content">
                <div className='home'>
                    <h1>INNOVATING TODAY FOR A SMARTER TOMORROW</h1>
                    <p>
                        We deliver innovative AR solutions, bridging physical and digital worlds.
                        With a dedicated team, we redefine user experiences for businesses, enhancing
                        engagement and efficiency. Join us as we revolutionize interaction through 
                        cutting-edge augmented reality.
                    </p>
                    <button className="explore-button">
                        Explore
                        <img src={exploreIcon} alt="" className="explore-arrow" />
                    </button>
                </div>
                <div className="home-image">
                    <img src={HomeImage} alt="Augmented Reality" />
                </div>
            </div>
            <div className='servicesDiv'>
                
                <OurServices/>
                
            </div>
            <div className='collaborators'>
                <p>Our Collaborators</p>
                <CollaboratorGrid />
            </div>
            <div className='ourTeam'>
                <Team />
            </div>

        </div>

    );
};

export default Home;
